module.exports = __webpack_public_path__ + "static/media/Estampa_Card7.a3ea5c94.png";